import React from "react";

export default function CustomerInfoModal({ data, close }) {
  return (
    <div className="modal modal-open">
      <div className="modal-box relative w-full max-w-3xl rounded-lg bg-white p-4 shadow-xl md:p-6">
        {/* Close Button */}
        <button
          className="hover-text-white btn btn-circle btn-xs absolute right-3 top-3 border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
          onClick={close}
        >
          ✕
        </button>

        {/* Header */}
        <div className="mb-4 rounded-lg bg-gradient-to-r from-orange-600 to-yellow-500 p-2 text-white">
          <h3 className="text-center text-xl font-extrabold md:text-2xl">
            Customer Information
          </h3>
        </div>

        {/* Customer Details */}
        <div className="grid grid-cols-1 items-center gap-2 text-gray-800 sm:grid-cols-2">
          <div className="flex items-center gap-2">
            <span className="font-semibold">Full Name:</span>
            <span className="flex-1">{data?.full_name}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">Email:</span>
            <span className="flex-1">{data?.email}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">Phone:</span>
            <span className="flex-1">{data?.phone_number}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">Alt. Phone:</span>
            <span className="flex-1">{data?.alternate_phone}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">Address:</span>
            <span className="flex-1">{data?.address}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">Passport:</span>
            <span className="flex-1">{data?.passport_number}</span>
          </div>
        </div>

        {/* Additional Info Grid */}
        {data && (
          <div className="mt-4 grid grid-cols-1 gap-4 text-gray-800 sm:grid-cols-2">
            {data.city_name && (
              <div>
                <span className="font-semibold">City:</span>{" "}
                <span>{data.city_name}</span>
              </div>
            )}
            {data.state_name && (
              <div>
                <span className="font-semibold">State:</span>{" "}
                <span>{data.state_name}</span>
              </div>
            )}
            {data.country_name && (
              <div>
                <span className="font-semibold">Country:</span>{" "}
                <span>{data.country_name}</span>
              </div>
            )}
            {data.postal_code && (
              <div>
                <span className="font-semibold">Postal Code:</span>{" "}
                <span>{data.postal_code}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
